 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-049dd54e":"8d610973","chunk-0a2221d3":"140ac2a4","chunk-1117b302":"cc581147","chunk-003181a8":"e70715d6","chunk-023c44e2":"e73095ca","chunk-18dc275e":"dbadbc09","chunk-19f8e16c":"ac3792f1","chunk-31ca5a0f":"03850ccd","chunk-120d8065":"5c431f63","chunk-188b1882":"dd94804f","chunk-41362192":"8192198e","chunk-a47386ba":"736b9d08","chunk-7a0f709c":"25f29b73","chunk-86799ae6":"671e5a7a","chunk-af4046c0":"23e466b2","chunk-b6596b18":"e34eb732","chunk-e5267ff6":"174f7377","chunk-259d3bb2":"593d5afa","chunk-11820216":"4f4bd9f7","chunk-17bbd880":"521d5a95","chunk-1febc2da":"e0c199c4","chunk-21fc9d92":"3411fe32","chunk-2334d097":"2e943098","chunk-28762aa8":"6b100caf","chunk-1e6237c1":"7a02e0b2","chunk-15bd451c":"38a5d3ee","chunk-18eecf1c":"403a4240","chunk-3b084688":"492d2e1b","chunk-40e6835a":"9eefc58a","chunk-6294699c":"5702ba04","chunk-432934f7":"bbd1cbc4","chunk-615cf46c":"1eb21d1a","chunk-700cc0cc":"0e6d8718","chunk-c6f18cae":"5e230a80","chunk-cd406e34":"05291e71","chunk-d3499802":"9bf0715a","chunk-ccfc6738":"0732124f","chunk-38211a28":"99ad0d1b","chunk-2c2280c1":"f9ab0dae","chunk-2b4505d5":"49a87b4e","chunk-2d0b8e29":"d9fe9cd5","chunk-2d0c4f94":"9a60af4c","chunk-2d0e549c":"bd115806","chunk-2d0e5fb3":"51b1c499","chunk-2d221f3a":"9524798f","chunk-2d22c341":"8c6a7b55","chunk-3086faf7":"31609298","chunk-41bb6bd0":"8df8dda9","chunk-722ec549":"40a3d342","chunk-a689099a":"4cdb3e00","chunk-0bad9914":"bf08f2eb","chunk-76b91524":"23cb3b50","chunk-327d68ff":"ca2f10c9","chunk-32fa970a":"6c34961b","chunk-3ea87833":"00b5a985","chunk-44cdc844":"c4c00a03","chunk-45f48ad6":"76f80357","chunk-4a419a16":"a84804ae","chunk-4b32a08c":"0a3bd6ff","chunk-54f4c5bd":"0c9e7022","chunk-58ac6939":"1ca61f8e","chunk-59c47205":"7aab26ce","chunk-62b251c7":"d79082b7","chunk-68eba9fa":"bca0be4f","chunk-0d8f0a92":"0e76f7e2","chunk-5e191156":"28d26dc1","chunk-1a1981b6":"0fc377d4","chunk-2d0cfa15":"9fa7cd7f","chunk-b59b2a38":"fcf607a2","chunk-7018d478":"934e5297","chunk-70498992":"d35f2f7d","chunk-78b622f5":"7ec224f1","chunk-7a1395ca":"e4d02bbe","chunk-a4cfc426":"40e22257","chunk-a5da3d60":"cf77a362","chunk-4716c70e":"61c03f0d","chunk-bb739142":"a951c397","chunk-cbda290c":"97f95572","chunk-d81aaf22":"a60809f0","chunk-287adf35":"ba0517c9","chunk-48db0cd8":"09af2161","chunk-f4628928":"095c102a","chunk-6a2eba80":"54a141f9","chunk-64d6bd33":"49b89854","chunk-eec4f05c":"02c353da","chunk-7545d4ea":"25c68b7c","chunk-2d0bdd88":"c1b77b3a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-049dd54e":1,"chunk-0a2221d3":1,"chunk-1117b302":1,"chunk-003181a8":1,"chunk-023c44e2":1,"chunk-18dc275e":1,"chunk-19f8e16c":1,"chunk-31ca5a0f":1,"chunk-120d8065":1,"chunk-188b1882":1,"chunk-41362192":1,"chunk-a47386ba":1,"chunk-7a0f709c":1,"chunk-86799ae6":1,"chunk-af4046c0":1,"chunk-b6596b18":1,"chunk-259d3bb2":1,"chunk-11820216":1,"chunk-1e6237c1":1,"chunk-15bd451c":1,"chunk-18eecf1c":1,"chunk-3b084688":1,"chunk-40e6835a":1,"chunk-6294699c":1,"chunk-432934f7":1,"chunk-615cf46c":1,"chunk-700cc0cc":1,"chunk-cd406e34":1,"chunk-ccfc6738":1,"chunk-38211a28":1,"chunk-2c2280c1":1,"chunk-2b4505d5":1,"chunk-3086faf7":1,"chunk-41bb6bd0":1,"chunk-722ec549":1,"chunk-a689099a":1,"chunk-0bad9914":1,"chunk-76b91524":1,"chunk-327d68ff":1,"chunk-3ea87833":1,"chunk-45f48ad6":1,"chunk-4b32a08c":1,"chunk-54f4c5bd":1,"chunk-58ac6939":1,"chunk-62b251c7":1,"chunk-0d8f0a92":1,"chunk-5e191156":1,"chunk-1a1981b6":1,"chunk-b59b2a38":1,"chunk-7018d478":1,"chunk-70498992":1,"chunk-78b622f5":1,"chunk-a4cfc426":1,"chunk-a5da3d60":1,"chunk-4716c70e":1,"chunk-bb739142":1,"chunk-cbda290c":1,"chunk-f4628928":1,"chunk-64d6bd33":1,"chunk-eec4f05c":1,"chunk-7545d4ea":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-049dd54e":"eddde662","chunk-0a2221d3":"08626210","chunk-1117b302":"79f3ad5e","chunk-003181a8":"54ab46e1","chunk-023c44e2":"54ab46e1","chunk-18dc275e":"fdf9b18e","chunk-19f8e16c":"9dc3b90f","chunk-31ca5a0f":"5a78075e","chunk-120d8065":"0174bac8","chunk-188b1882":"362f44c9","chunk-41362192":"9274bd54","chunk-a47386ba":"99b83ce9","chunk-7a0f709c":"646a25b0","chunk-86799ae6":"4a78a2bc","chunk-af4046c0":"a9f09e56","chunk-b6596b18":"74fc0cef","chunk-e5267ff6":"31d6cfe0","chunk-259d3bb2":"20f9ee47","chunk-11820216":"cea75bec","chunk-17bbd880":"31d6cfe0","chunk-1febc2da":"31d6cfe0","chunk-21fc9d92":"31d6cfe0","chunk-2334d097":"31d6cfe0","chunk-28762aa8":"31d6cfe0","chunk-1e6237c1":"bc93c67b","chunk-15bd451c":"eb96b302","chunk-18eecf1c":"2eeb3158","chunk-3b084688":"d56b8c5b","chunk-40e6835a":"eb96b302","chunk-6294699c":"7b11d1df","chunk-432934f7":"9e8b5938","chunk-615cf46c":"732c1835","chunk-700cc0cc":"9e8b5938","chunk-c6f18cae":"31d6cfe0","chunk-cd406e34":"73badc34","chunk-d3499802":"31d6cfe0","chunk-ccfc6738":"bc6b79a3","chunk-38211a28":"fab6efe0","chunk-2c2280c1":"c004ea2e","chunk-2b4505d5":"534e49d5","chunk-2d0b8e29":"31d6cfe0","chunk-2d0c4f94":"31d6cfe0","chunk-2d0e549c":"31d6cfe0","chunk-2d0e5fb3":"31d6cfe0","chunk-2d221f3a":"31d6cfe0","chunk-2d22c341":"31d6cfe0","chunk-3086faf7":"3783efae","chunk-41bb6bd0":"7dd9f656","chunk-722ec549":"34d1485d","chunk-a689099a":"27b01eef","chunk-0bad9914":"85389b9e","chunk-76b91524":"2f4a94f9","chunk-327d68ff":"0a2b9a53","chunk-32fa970a":"31d6cfe0","chunk-3ea87833":"f11d81eb","chunk-44cdc844":"31d6cfe0","chunk-45f48ad6":"4038d8e1","chunk-4a419a16":"31d6cfe0","chunk-4b32a08c":"05e2ec3e","chunk-54f4c5bd":"06ce8b27","chunk-58ac6939":"f17eaaec","chunk-59c47205":"31d6cfe0","chunk-62b251c7":"db161475","chunk-68eba9fa":"31d6cfe0","chunk-0d8f0a92":"21b1344c","chunk-5e191156":"fefd9cf0","chunk-1a1981b6":"4b99992c","chunk-2d0cfa15":"31d6cfe0","chunk-b59b2a38":"ca7dd79c","chunk-7018d478":"bc6b79a3","chunk-70498992":"e7a79b1e","chunk-78b622f5":"e1da19e8","chunk-7a1395ca":"31d6cfe0","chunk-a4cfc426":"2c84a8a3","chunk-a5da3d60":"5482ff55","chunk-4716c70e":"8a0b6498","chunk-bb739142":"bf95ea4e","chunk-cbda290c":"f17eaaec","chunk-d81aaf22":"31d6cfe0","chunk-287adf35":"31d6cfe0","chunk-48db0cd8":"31d6cfe0","chunk-f4628928":"98dd07e5","chunk-6a2eba80":"31d6cfe0","chunk-64d6bd33":"6f38cfe7","chunk-eec4f05c":"3a6d729f","chunk-7545d4ea":"bdc62693","chunk-2d0bdd88":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "http://41.227.31.124:8080/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
